import { FormSection } from '@openx/components-core/lib/FormSection/FormSection';
import { RHFTextField } from '@openx/components-core/lib/TextField/RHFTextField';
import { RIGHT_COLUMN_WIDTH } from '@openx/constants/form';
import type { Path } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { optionalSuffix } from '../../utils/optionalSuffix';
import type { AudienceForm } from '../types';

export const AudienceDetails = () => {
  const { t } = useTranslation();

  return (
    <FormSection divider title={t('Audience Details')} rightColumnSize={RIGHT_COLUMN_WIDTH}>
      <RHFTextField
        name={'name' satisfies Path<AudienceForm>}
        label={t('Audience Name')}
        placeholder={t('Type your audience name.')}
        fullWidth
        margin="dense"
        dataTest="audience-name"
      />

      <RHFTextField
        name={'description' satisfies Path<AudienceForm>}
        label={optionalSuffix(t('Description'))}
        placeholder={t('Enter audience description here.')}
        fullWidth
        margin="dense"
        dataTest="description-name"
        multiline
        minRows={4}
        maxRows={4}
      />
    </FormSection>
  );
};
